import table from './table'

export default {
    useStatusNotification: 'Statusbenachrichtigung verwenden',
    useStatusNotificationDescription: 'Wenn aktiviert, bei einer Statusänderung in diesen Status eine E-Mail verschickt.',

    forOrganisation: 'Für Organisation',
    mailTemplate: 'E-Mailvorlage',
    sendTo: 'Benachrichtigung senden an',
    sendToDescription: 'Jede Option, die aktiviert ist, erhält eine Benachrichtigung.',
    toUser: 'An die Ansprechperson',
    toOrganisation: 'An die Kontaktperson des Antragstellers',
    toAssociation: 'An den Verband',
    toRp: 'An das Regierungspräsidium',
    toCustom: 'An eine benutzerdefinierte E-Mail-Adresse',
    toCustomHelpText: 'Gib hier E-Mailadressen ein, die die Benachrichtigung erhalten sollen. Trenne mehrere E-Mailadressen mit einem Komma.',

    notificationMode: 'Benachrichtigungsmodus',
    notificationModes: {
        direct: 'Direkt',
        directHelpText: 'Die Benachrichtigung wird direkt nach der Statusänderung verschickt.',
        editable: 'Bearbeitbar',
        editableHelpText: 'Die Benachrichtigung kann nach der Statusänderung noch bearbeitet werden. Dies gilt nur für Statusänderungen im Bereich der Vorgänge im Verwaltungsbereich. Automatische Statusänderungen versenden E-Mails immer direkt.'
    },

    editStatusNotification: 'Statusbenachrichtigung bearbeiten',
    saveStatusNotificationEdit: 'Änderungen speichern',
    editStatusNotificationSuccess: 'Die Statusbenachrichtigung wurde erfolgreich aktualisiert.',
    editStatusNotificationError: 'Beim Aktualisieren der Statusbenachrichtigung ist ein Fehler aufgetreten.',

    deleteStatusNotification: 'Statusbenachrichtigung löschen',
    deleteStatusNotificationText: 'Möchtest du die Statusbenachrichtigung wirklich löschen?',
    deleteStatusNotificationSuccess: 'Die Statusbenachrichtigung wurde erfolgreich gelöscht.',
    deleteStatusNotificationError: 'Beim Löschen der Statusbenachrichtigung ist ein Fehler aufgetreten.',

    editStatusNotificationCustomText: 'Benutzerdefinierter Text für Statusänderung',
    editStatusNotificationCustomTextHelpText: 'Bei dieser Statusänderung kann ein benutzerdefinierter Text für die E-Mail eingegeben werden. Dieser wird dann in die E-Mail eingedruckt.',
    customTextSetsCancellationComment: 'Außerdem setzt dieser benutzerdefinierte Text den Stornokommentar.',
    customText: 'Benutzerdefinierter Text',
    saveCustomText: 'Diesen Text übernehmen',

    table,
}